module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "change-field"
  }, [_c('el-dialog', {
    attrs: {
      "title": "Change Field",
      "visible": _vm.show
    },
    on: {
      "update:visible": function($event) {
        _vm.show = $event
      }
    }
  }, [_c('span', [_c('el-select', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.fields.length),
      expression: "!fields.length"
    }],
    attrs: {
      "placeholder": "New field"
    },
    model: {
      value: (_vm.newField),
      callback: function($$v) {
        _vm.newField = $$v
      },
      expression: "newField"
    }
  }, _vm._l((_vm.fields), function(field) {
    return _c('el-option', {
      key: field.id,
      attrs: {
        "label": field.field_name,
        "value": field.id
      }
    })
  }))], 1), _vm._v(" "), (_vm.fields.length) ? _c('div', {
    staticClass: "moveLightNickname"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Nickname (optional)"
    },
    model: {
      value: (_vm.light.nickname),
      callback: function($$v) {
        _vm.$set(_vm.light, "nickname", $$v)
      },
      expression: "light.nickname"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "cancel"
    },
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": !_vm.newField,
      "type": "save"
    },
    on: {
      "click": _vm.changeField
    }
  }, [_vm._v("Move")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-703cc5a3","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Lights/ChangeFieldModal.vue
// module id = 1170
// module chunks = 7